export const promotions_top_block = 'promotions_top_block';
